import { Observable } from 'rxjs/Observable';
import { Injectable } from "@angular/core";
import { KeystoneHttpClient } from '../../../keystone-http';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class AuthenticationHttpService {
  constructor(
    private authHttp: KeystoneHttpClient, 
    private http: HttpClient){

    }

  login(email: string, password: string): Observable<Object>{
    return this.http.post(this.authHttp.getBaseUrl() + '/login', {
      email: email,
      password: password
    })
  }

  registation(name: string, password: string, email: string, privacy: boolean): Observable<Object>{
    return this.http.post(this.authHttp.getBaseUrl() + '/register', {
      name: {full: name},
      email: email,
      password: password,
      privacy: privacy
    })
  }

  resendEmail(email: string, resend: boolean){
    return this.http.post(this.authHttp.getBaseUrl() + '/helpLogin', {
      email: email,
      resend: resend
    })
  }

  resetPassword(email: string, reset: boolean): Observable<Object>{
    return this.http.post(this.authHttp.getBaseUrl() + '/helpLogin', {
      reset: reset,
      email: email
    })
  }

}


// WEBPACK FOOTER //
// ./src/app/core/authentication/authentication-http.service.ts